import TagInput from "./TagInput";

function FaqForm({
  title,
  form,
  onChange,
  onSubmit,
  onCancel,
  submitting,
  languages,
  statuses,
}) {
  return (
    <form
      onSubmit={onSubmit}
      className="bg-white border border-orange-200 dark:border-orange-900/40 rounded-xl p-8 flex flex-col gap-3"
    >
      <h3 className="font-semibold text-slate-900 dark:text-gray-100">
        {title}
      </h3>
      <label className="flex flex-col gap-1">
        <span className="text-sm font-medium text-slate-600 dark:text-gray-300">
          Question
        </span>
        <textarea
          value={form.question}
          onChange={(e) => onChange({ ...form, question: e.target.value })}
          required
          className="px-3 py-2 border border-slate-200 dark:border-gray-600 rounded-lg text-sm bg-white dark:bg-gray-800 text-slate-900 dark:text-gray-100 focus:outline-none focus:ring-1 focus:ring-orange-400"
        />
      </label>
      <label className="flex flex-col gap-1">
        <span className="text-sm font-medium text-slate-600 dark:text-gray-300">
          Answer
        </span>
        <textarea
          value={form.answer}
          onChange={(e) => onChange({ ...form, answer: e.target.value })}
          required
          className="px-3 py-2 border border-slate-200 dark:border-gray-600 rounded-lg text-sm bg-white dark:bg-gray-800 text-slate-900 dark:text-gray-100 focus:outline-none focus:ring-1 focus:ring-orange-400"
        />
      </label>
      <label className="flex flex-col gap-1">
        <span className="text-sm font-medium text-slate-600 dark:text-gray-300">
          Language
        </span>
        <select
          value={form.language}
          onChange={(e) => onChange({ ...form, language: e.target.value })}
          className="px-3 py-2 border border-slate-200 dark:border-gray-600 rounded-lg text-sm bg-white dark:bg-gray-800 text-slate-900 dark:text-gray-100 focus:outline-none focus:ring-1 focus:ring-orange-400"
        >
          {languages.map((l) => (
            <option key={l} value={l}>
              {l}
            </option>
          ))}
        </select>
      </label>
      <label className="flex flex-col gap-1">
        <span className="text-sm font-medium text-slate-600 dark:text-gray-300">
          Source URL (optional)
        </span>
        <input
          value={form.source_url}
          onChange={(e) => onChange({ ...form, source_url: e.target.value })}
          className="px-3 py-2 border border-slate-200 dark:border-gray-600 rounded-lg text-sm bg-white dark:bg-gray-800 text-slate-900 dark:text-gray-100 focus:outline-none focus:ring-1 focus:ring-orange-400"
        />
      </label>
      <label className="flex flex-col gap-1">
        <span className="text-sm font-medium text-slate-600 dark:text-gray-300">
          Status
        </span>
        <select
          value={form.status}
          onChange={(e) => onChange({ ...form, status: e.target.value })}
          className="px-3 py-2 border border-slate-200 dark:border-gray-600 rounded-lg text-sm bg-white dark:bg-gray-800 text-slate-900 dark:text-gray-100 focus:outline-none focus:ring-1 focus:ring-orange-400"
        >
          {statuses.map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </select>
      </label>
      <label className="flex flex-col gap-1">
        <span className="text-sm font-medium text-slate-600 dark:text-gray-300">
          Tags
        </span>
        <span className="text-xs text-slate-400 dark:text-gray-500">
          Free-form labels, separate from Category.
        </span>
        <TagInput
          tags={form.tags}
          onChange={(tags) => onChange({ ...form, tags })}
        />
      </label>
      <div className="flex gap-2">
        <button
          type="submit"
          disabled={submitting}
          className="px-4 py-2 text-sm font-medium text-white bg-orange-500 hover:bg-orange-600 rounded-lg transition-colors disabled:opacity-50"
        >
          {submitting ? "Saving..." : "Save"}
        </button>
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 text-sm font-medium text-slate-700 dark:text-gray-300 bg-white dark:bg-gray-800 border border-slate-200 dark:border-gray-600 rounded-lg hover:bg-slate-50 dark:hover:bg-gray-700 transition-colors"
        >
          Cancel
        </button>
      </div>
    </form>
  );
}

export default FaqForm;
